import { render, staticRenderFns } from "./CenterIndex.vue?vue&type=template&id=835a4084&scoped=true"
import script from "./CenterIndex.vue?vue&type=script&lang=js"
export * from "./CenterIndex.vue?vue&type=script&lang=js"
import style0 from "./CenterIndex.vue?vue&type=style&index=0&id=835a4084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835a4084",
  null
  
)

export default component.exports